// removed by extract-text-webpack-plugin
module.exports = {"valueBlack":"#222628","placeholderGray":"#9297A3","container":"container-1lFbC container-3-GEX","inputContainer":"inputContainer-1VnJ4","input":"input-2l94o input-2t6DG","selected":"selected-3TiSN","arrow":"arrow-38xpU","error":"error-38FM6 inputError-2jP1m","slim":"slim-RZW9s slim-2C1LB"};


//////////////////
// WEBPACK FOOTER
// ./src/components/forms/SelectField/_selectField.css
// module id = 330
// module chunks = 1